<app-create-partners />

<div
  class="row"
  *ngIf="
    permissionsService.readPermission ||
    permissionsService.editPermission ||
    permissionsService.archivePermission
  "
>
  <div class="col-10 mb-3">
    <h2 class="title-list">List of Partners</h2>
  </div>
  <div class="col-1 text-end">
    <button
      *ngIf="
        permissionsService.editPermission && permissionsService.readPermission
      "
      class="btn btn-secondary"
      (click)="exportListPartnersToExcel()"
    >
      <i class="bi bi-file-earmark-excel"></i>
    </button>
  </div>
  <div class="col-1 text-end">
    <button
      class="btn btn-secondary" appTooltip="Show Archived Partners" (click)="isFilteredByStatus ? clearFilter() : filterByStatus(2)">
      <i class="bi bi-archive"></i>
    </button>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="input-group mb-3">
      <span class="input-group-text" id="basic-addon1">
        <i class="bi bi-search"></i>
      </span>
      <input
        type="text"
        class="form-control input-label"
        placeholder="Search"
        [(ngModel)]="textoBusqueda"
        (input)="onSearchChange()"
      />
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="table-responsive rounded-5">
      <table class="table table-striped mb-0">
        <caption class="d-none">
          List of partners and their details
        </caption>
        <thead class="head-table" style="white-space: nowrap;">
          <tr>
            <th class="px-4 py-3 align-middle">Partner ID</th>
            <th class="px-4 py-3 align-middle">Name</th>
            <th class="px-4 py-3 align-middle">Email</th>
            <th class="px-4 py-3 align-middle">Contact Number</th>
            <th class="px-4 py-3 align-middle">Total Staff</th>
            <th class="px-4 py-3 align-middle">Total Customers</th>
            <th class="px-4 py-3 align-middle">Status</th>
            <th class="px-4 py-3 align-middle">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let partner of partners
                | search : textoBusqueda : camposBusqueda
                | slice : (currentPage - 1) * 10 : currentPage * 10
            "
          >
            <td
              class="px-4 py-3 align-middle"
              [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'"
              title="{{ partner.userId }}"
            >
              {{ partner.userId }}
            </td>
            <td
              class="px-4 py-3 align-middle"
              [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'"
              title="{{ partner.userNames }}"
            >
              {{ partner.userNames }}
            </td>
            <td
              class="px-4 py-3 align-middle"
              [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'"
              title="{{ partner.userMail }}"
            >
              {{ partner.userMail }}
            </td>
            <td
              class="px-4 py-3 align-middle"
              [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'"
              title="{{ partner.userPhone }}"
            >
              {{ partner.userPhone }}
            </td>
            <td
              class="px-4 py-3 align-middle"
              [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'"
              title="{{ partner.totalStaff }}"
            >
              {{ partner.totalStaff }}
            </td>
            <td
              class="px-4 py-3 align-middle"
              [style.opacity]="partner.userStatus === 0 ? '0.6' : '1'"
              title="{{ partner.totalCustomers }}"
            >
              {{ partner.totalCustomers }}
            </td>
            <td class="px-4 py-3 align-middle">
              <div
                *ngIf="partner.userStatus === 0 || partner.userStatus === 1"
                class="form-check form-switch"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="partner.userStatus"
                  id="flexSwitchCheckDefault"
                  [checked]="partner.userStatus === 1"
                  [disabled]="!permissionsService.editPermission"
                  (change)="
                    toggleStatus($event, partner);
                    setSelectedPartner(partner);
                    openConfirmationModal(partner)
                  "
                  data-bs-toggle="modal"
                  data-bs-target="#modalSwitch"
                />
              </div>
              <div *ngIf="partner.userStatus === 2">
                <span class="archived">Archived</span>
              </div>
            </td>
            <td class="px-4 py-3 align-middle">
                <div class="d-flex gap-2">
                    <!-- Botón Editar con icono pencil-square -->
                    <button *ngIf="
                    partner.userStatus !== 2 &&
                    permissionsService.editPermission
                  "
                            class="btn btn-info"
                            (click)="navigateToPartnerCustomers(partner)"
                            style="background-color: #d1e7dd; border: 3px solid #d1e7dd"
                            appTooltip="Edit Partner">
                        <i class="bi bi-pencil-square" style="color: #146c43"></i>
                    </button>

                    <!-- Кнопка «Удалить» со значком «Архив» -->
                    <button *ngIf="
                    partner.userStatus !== 2 &&
                    permissionsService.archivePermission
                  "
                            class="btn btn-danger"
                            data-bs-toggle="modal"
                            data-bs-target="#modalArchive"
                            (click)="setArchivedPartner(partner)"
                            style="background-color: #f8d7da; border: 3px solid #f8d7da"
                            appTooltip="Archive Partner">
                        <i class="bi bi-archive" style="color: #b02a37"></i>
                    </button>

                    <!-- Кнопка «Восстановить» со значком «Архив» -->
                    <button *ngIf="
                    partner.userStatus === 2 &&
                    permissionsService.archivePermission
                  "
                            class="btn btn-primary"
                            data-bs-toggle="modal"
                            data-bs-target="#modalArchive"
                            (click)="setArchivedPartner(partner)"
                            style="background-color: #7ab956; border: 3px solid #7ab956"
                            appTooltip="Restore Partner">
                        <i class="bi bi-archive"></i>
                    </button>

                    <!-- Botón View con icono eye -->
                    <button class="btn btn-success"
                            style="background-color: #cfe2ff; border: 3px solid #cfe2ff"
                            *ngIf="permissionsService.readPermission"
                            (click)="navigateToPartnerView(partner)"
                            appTooltip="View Partner">
                        <i class="bi bi-eye" style="color: #0a58ca"></i>
                    </button>
                    <!-- Botón Asignar Users con icono de asignación de usuarios -->
                    <button *ngIf="
                    permissionsService.readPermission
                  "
                            class="btn btn-info"
                            (click)="navigateToCustomerUsers(partner)"
                            style="background-color: #d1e7dd; border: 3px solid #d1e7dd"
                            appTooltip="Assign Staff">
                        <i class="bi bi-person-plus" style="color: #146c43"></i>
                    </button>
                </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="row d-flex align-items-center justify-content-between">
  <div class="col-2">
    <label>
      Showing {{ (currentPage - 1) * recordsPerPage + 1 }} to
      {{
        currentPage * recordsPerPage < partners.length
          ? currentPage * recordsPerPage
          : partners.length
      }}
      out of {{ partners.length }} entries
    </label>
  </div>
  <div class="col-7">
    <div class="col-12 pagination text-left">
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a
              class="page-link"
              href="javascript:void(0)"
              tabindex="-1"
              aria-disabled="true"
              (click)="previousPage()"
            >
              <i class="bi bi-chevron-left"></i>
            </a>
          </li>
          <ng-container *ngFor="let page of pages">
            <li class="page-item" [class.active]="page === currentPage">
              <a
                class="page-link"
                href="javascript:void(0)"
                (click)="changePage(page)"
                >{{ page }}</a
              >
            </li>
          </ng-container>
          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
              <i class="bi bi-chevron-right"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>

<!-- Modal -->
<div
  class="modal fade"
  id="modalSwitch"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title"
          id="exampleModalLabel"
          style="font-weight: bold"
        >
          Partner Active/Inactive
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="updatePartnerStatus(false)"
        ></button>
      </div>
      <div class="modal-body">
        Are you sure you want to Activate/Deactivate this partner?
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
          (click)="updatePartnerStatus(false)"
        >
          Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          data-bs-dismiss="modal"
          (click)="updatePartnerStatus(true)"
        >
          Yes, Activate/Desactivate
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div
  class="modal fade"
  id="modalArchive"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
          <h5 class="modal-title"
              id="exampleModalLabel"
              style="font-weight: bold">
              Partner {{isFilteredByStatus ? 'Restore' : 'Archive'}}
          </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="updatePartnerStatus(false)"
        ></button>
      </div>
      <div class="modal-body">
          Are you sure you want to {{isFilteredByStatus ? 'Restore' : 'Archive'}} this partner?
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
          (click)="updatePartnerStatus(false)"
        >
          Close
        </button>
        <button type="button"
                class="btn btn-primary"
                data-bs-dismiss="modal"
                (click)="updatePartnerStatus(true)">
            Yes, {{isFilteredByStatus ? 'Restore' : 'Archive'}}
        </button>
      </div>
    </div>
  </div>
</div>
